import type { AssetViewModel, ContactPersonViewModel } from '@trinnvis/dabih-api-client';
import { LocalDate } from '../../../utilities/local-date';
import type { AssetViewModelWithEvents } from './asset-view-model-with-events';
import { findLast, sortBy } from 'lodash';
import { getDoneBy } from './get-done-by';
import { getAssetControlStatusText } from './get-asset-control-status-text';
import { dateTimeDescription } from '../../utilities';
import type { NameEntry } from '../employees/name-entry';
import type { EventModel } from '../events/event-model';
import { t as translate } from 'src/i18n';

export function toAssetListItem(
  originalItem: AssetViewModel,
  events: EventModel[],
  now: LocalDate,
  employeeNames: NameEntry[],
  contacts: ContactPersonViewModel[],
): AssetViewModelWithEvents {
  const nowAsString = now.toString();
  const item: AssetViewModelWithEvents = { ...originalItem, events: [] };
  const eventsWithThisAsset = events.filter((e) => {
    const occurrences = e.eventOccurrences.filter((o) => o.relatedAssets?.map((r) => r.assetUuid).includes(item.uuid));
    return occurrences.length > 0;
  });

  item.events = eventsWithThisAsset
    .filter((e) => {
      return e.name !== '';
    })
    .map((e) => {
      const sortedOccurrences = sortBy(e.eventOccurrences, [(e) => e.date]);
      const occurrences = sortedOccurrences
        .filter((o) => o.relatedAssets?.map((r) => r.assetUuid).includes(item.uuid))
        .map((t) => {
          let status: 'NONE' | 'OK' | 'NOT_OK' | 'DONE' = 'NONE';
          let statusText = '';
          if (t.doneDate !== null && t.doneDate !== undefined && t.doneDate !== '') {
            const doneDate = LocalDate.fromString(t.doneDate).toStringForDisplayWithYear();
            status = 'DONE';
            statusText =
              translate('assets.controlStatusDonePrefix') +
              doneDate +
              getDoneBy(t.doneByEmployeeUuid, employeeNames, contacts);
          }
          const assetControl = (t.relatedAssets ?? []).find((r) => {
            return r.assetUuid === item.uuid;
          });
          if (assetControl) {
            if (assetControl.assetStatus === 'OK' || assetControl.assetStatus === 'NOT_OK') {
              status = assetControl.assetStatus;
            }
            statusText = getAssetControlStatusText(assetControl, employeeNames, contacts);
          }

          return {
            eventUuid: t.uuid,
            dateTimeForSorting: t.date + ' ' + t.time,
            dateTimeDisplay: dateTimeDescription(t.date, t.time ?? ''),
            status: status,
            statusText: statusText,
            href: 'eventOccurrences/' + t.uuid,
          };
        });

      return {
        name: e.name,
        prev: findLast(occurrences, (i) => i.dateTimeForSorting < nowAsString),
        next: occurrences.find((i) => i.dateTimeForSorting >= nowAsString),
        occurrences: occurrences,
      };
    });
  return item;
}
